import React, { Fragment } from 'react'

import { connect } from 'react-redux'

import { get_List_Kontrak, get_Job_Action_Id } from '../../../../Store/Actions/Job.Action'
import { get_Account_Action_Id } from '../../../../Store/Actions/Account.Action'

import { Collapse } from '@mui/material'

import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

import GenericModals from '../../../Containers/GenericModals'
import CoTable from '../../../Containers/Table'
import SubmitKontrak from './Modal/Kontrak/SubmitKontrak'
import DetailKontrak from './Modal/Kontrak/DetailKontrak'

class Kontrak extends React.Component {
    state = {
        MenungguOpen: true,
        SelesaiOpen: false,
    }

    componentDidMount() {
        this.props.get_List_Kontrak()
    }

    handleMenungguOpen = () => {
        this.setState({ MenungguOpen: !this.state.MenungguOpen })
    }

    handleSelesaiOpen = () => {
        this.setState({ SelesaiOpen: !this.state.SelesaiOpen })
    }

    onClickActionId = (JobId, AccountId) => {
        this.props.get_Job_Action_Id(JobId)
        this.props.get_Account_Action_Id(AccountId)
    }
    render() {
        const isListKontrakLoading = this.props.isListKontrakLoading
        const ListKontrak = this.props.ListKontrak

        const HeadData = [
            {
                Nama: 'No',
                width: '5%',
            },
            {
                Nama: 'No Registrasi',
                width: '10%',
            },
            {
                Nama: 'Nama',
                width: '10%',
            },
            {
                Nama: 'Posisi',
                width: '10%',
            },
            {
                Nama: 'Submit',
                width: '10%',
            },
        ]

        const FilteredList = ListKontrak ? ListKontrak.filter((item, index) => (
            item.KoAccId === null
        )) : []

        const BodyData = FilteredList.map((item, index) => {
            return {
                index: index + 1,
                Noreg: item.Id,
                Nama: item.BiodataNama,
                Posisi: item.JobListNama,
                Detail: (
                    <GenericModals
                        size='s'
                        Buttonvariant='contained'
                        header='Submit Kontrak'
                        body={<SubmitKontrak />}
                        Buttoncolor='primary'
                        ButtononClickeven={() => this.onClickActionId(item.JobListId, item.AccountId)}
                        Buttonlabel={'Submit'}
                    />
                )
            }
        })

        const HeadData2 = [
            {
                Nama: 'No',
                width: '5%',
            },
            {
                Nama: 'No Registrasi',
                width: '10%',
            },
            {
                Nama: 'Nama',
                width: '10%',
            },
            {
                Nama: 'Posisi',
                width: '10%',
            },
            {
                Nama: 'Status',
                width: '10%',
            },
            {
                Nama: 'Submit',
                width: '10%',
            },
        ]

        const FilteredList2 = ListKontrak ? ListKontrak.filter((item, index) => (
            item.KoStatus !== null
        )) : []

        const BodyData2 = FilteredList2.map((item, index) => {
            return {
                index: index + 1,
                Noreg: item.Id,
                Nama: item.BiodataNama,
                Posisi: item.JobListNama,
                Status: (
                    <span
                        style={{ color: item.KoStatus ? item.KoStatus === 'Accept' ? 'green' : 'red' : 'black' }}
                    >
                        {item.KoStatus}
                    </span>
                ),
                Detail: (
                    <GenericModals
                        size='l'
                        header='Kontrak Detail'
                        body={<DetailKontrak />}
                        Buttoncolor='primary'
                        ButtononClickeven={() => this.onClickActionId(item.JobListId, item.AccountId)}
                        Buttonlabel={'Detail'}
                    />
                )
            }
        })

        const {
            MenungguOpen,
            SelesaiOpen,
        } = this.state

        const RowDataInOnePage = 5
        return (
            <Fragment>
                <h2>
                    Kontrak
                </h2>
                <h3
                    onClick={this.handleMenungguOpen}
                    style={{ display: 'flex', alignContent: 'center', verticalAlign: 'center', cursor: 'pointer' }}
                >
                    Menunggu{MenungguOpen ? <ExpandLess /> : <ExpandMore />}
                </h3>
                <Collapse in={MenungguOpen} timeout="auto" unmountOnExit>
                    <CoTable
                        TableId={'Kontrak_Menunggu'}
                        HeadData={HeadData}
                        Data={BodyData}
                        isHeadLoading={isListKontrakLoading}
                        isBodyLoading={isListKontrakLoading}
                        isPagination={BodyData.length > RowDataInOnePage ? true : false}
                        MaxRowOnPage={RowDataInOnePage}
                        isPaginationLoading={isListKontrakLoading}
                        PaginationCounter={
                            BodyData.length / RowDataInOnePage > Math.floor(BodyData.length / RowDataInOnePage) ?
                                Math.floor(BodyData.length / RowDataInOnePage) + 1 :
                                BodyData.length / RowDataInOnePage
                        }
                    />
                </Collapse>
                <div
                    style={{ margin: '0 0 5% 0' }}
                >
                    <h3
                        onClick={this.handleSelesaiOpen}
                        style={{ display: 'flex', alignContent: 'center', verticalAlign: 'center', cursor: 'pointer' }}
                    >
                        Selesai{SelesaiOpen ? <ExpandLess /> : <ExpandMore />}
                    </h3>
                    <Collapse in={SelesaiOpen} timeout="auto" unmountOnExit>
                        <CoTable
                            TableId={'Kontrak_Selesai'}
                            HeadData={HeadData2}
                            Data={BodyData2}
                            isHeadLoading={isListKontrakLoading}
                            isBodyLoading={isListKontrakLoading}
                            isPagination={BodyData2.length > RowDataInOnePage ? true : false}
                            MaxRowOnPage={RowDataInOnePage}
                            isPaginationLoading={isListKontrakLoading}
                            PaginationCounter={
                                BodyData2.length / RowDataInOnePage > Math.floor(BodyData2.length / RowDataInOnePage) ?
                                    Math.floor(BodyData2.length / RowDataInOnePage) + 1 :
                                    BodyData2.length / RowDataInOnePage
                            }
                        />
                    </Collapse>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    isListKontrakLoading: state.Job.isListKontrakLoading,
    ListKontrak: state.Job.ListKontrak,
})

export default connect(mapStateToProps, { get_List_Kontrak, get_Job_Action_Id, get_Account_Action_Id })(Kontrak)